import type { JsonObject, JsonValue } from '../../common.types';
import type { LosslessNumber } from '../../lossless-json-codec';
import type { CloverCnpTokenSaleChargeBody } from './clover/clover-cnp-token-sale.types';
import type { CloverLifecycleFinalizationResponsePayload } from './clover/clover-lifecycle-finalization.types';
import type { CloverLifecyclePreflightResponsePayload } from './clover/clover-lifecycle-preflight.types';
import type { CloverRefundResponseDetails } from './clover/clover-refund.types';
import type { CloverTerminalSaleResponseLifecyclePayload } from './clover/clover-terminal-sale-lifecycle.types';
import type { CloverTransactionDetailsPaymentBody } from './clover/clover-transaction-details.types';
import type { CloverVoidResponseDetails } from './clover/clover-void.types';

export const GatewayLifecycleResponseType = {
    CARDPOINTE_AUTH: 'cardpointe_auth_response_v1',
    CARDPOINTE_AUTH_V2: 'cardpointe_auth_response_v2',
    CARDPOINTE_AUTH_HTTP_ERROR: 'cardpointe_auth_http_error_response_v1',
    CARDPOINTE_AUTH_HTTP_ERROR_V2: 'cardpointe_auth_http_error_response_v2',
    CARDPOINTE_AUTH_INVALID_JSON: 'cardpointe_auth_invalid_json_response_v1',
    CARDPOINTE_FUNDING: 'cardpointe_funding_response_v1',
    CARDPOINTE_FUNDING_V2: 'cardpointe_funding_response_v2',
    CARDPOINTE_BROWSER_TOKENIZATION: 'cardpointe_browser_tokenization_response_v1',
    CARDPOINTE_BROWSER_TOKENIZATION_V2: 'cardpointe_browser_tokenization_response_v2',
    CARDPOINTE_HOSTED_IFRAME_TOKENIZATION: 'cardpointe_hosted_iframe_tokenization_response_v1',
    CARDPOINTE_HOSTED_IFRAME_TOKENIZATION_V2: 'cardpointe_hosted_iframe_tokenization_response_v2',
    CARDPOINTE_INQUIRE: 'cardpointe_inquire_response_v1',
    CARDPOINTE_INQUIRE_V2: 'cardpointe_inquire_response_v2',
    CARDPOINTE_INQUIRE_BY_ORDER_ID: 'cardpointe_inquire_by_orderid_response_v1',
    CARDPOINTE_INQUIRE_BY_ORDER_ID_V2: 'cardpointe_inquire_by_orderid_response_v2',
    CARDPOINTE_LIFECYCLE_FINALIZATION: 'cardpointe_lifecycle_finalization_response_v1',
    CARDPOINTE_LIFECYCLE_PREFLIGHT: 'cardpointe_lifecycle_preflight_response_v1',
    CARDPOINTE_REFUND: 'cardpointe_refund_response_v1',
    CARDPOINTE_REFUND_V2: 'cardpointe_refund_response_v2',
    CARDPOINTE_TERMINAL_SALE: 'cardpointe_terminal_sale_response_v1',
    CARDPOINTE_TERMINAL_SALE_V2: 'cardpointe_terminal_sale_response_v2',
    CARDPOINTE_TERMINAL_TOKENIZATION_V2: 'cardpointe_terminal_tokenization_response_v2',
    CARDPOINTE_TERMINAL_CANCEL_V2: 'cardpointe_terminal_cancel_response_v2',
    CARDPOINTE_VOID: 'cardpointe_void_response_v1',
    CARDPOINTE_VOID_V2: 'cardpointe_void_response_v2',
    CLOVER_CHARGE: 'clover_charge_response_v1',
    CLOVER_CHARGE_V2: 'clover_charge_response_v2',
    CLOVER_BROWSER_TOKENIZATION: 'clover_browser_tokenization_response_v1',
    CLOVER_BROWSER_TOKENIZATION_V2: 'clover_browser_tokenization_response_v2',
    CLOVER_CHARGE_HTTP_ERROR: 'clover_charge_http_error_response_v1',
    CLOVER_CHARGE_INVALID_JSON: 'clover_charge_invalid_json_response_v1',
    CLOVER_LIFECYCLE_FINALIZATION: 'clover_lifecycle_finalization_response_v1',
    CLOVER_LIFECYCLE_PREFLIGHT: 'clover_lifecycle_preflight_response_v1',
    CLOVER_PAYMENT: 'clover_payment_response_v1',
    CLOVER_PAYMENT_V2: 'clover_payment_response_v2',
    CLOVER_PAYMENT_EXTERNAL: 'clover_payment_external_response_v1',
    CLOVER_PAYMENT_EXTERNAL_V2: 'clover_payment_external_response_v2',
    CLOVER_PAYMENT_EXTERNAL_HTTP_ERROR: 'clover_payment_external_http_error_response_v1',
    CLOVER_PAYMENT_EXTERNAL_HTTP_ERROR_V2: 'clover_payment_external_http_error_response_v2',
    CLOVER_WEBHOOK_PAYMENT_RETRIEVAL: 'clover_webhook_payment_retrieval_response_v1',
    CLOVER_WEBHOOK_PAYMENT_RETRIEVAL_V2: 'clover_webhook_payment_retrieval_response_v2',
    CLOVER_REFUND: 'clover_refund_response_v1',
    CLOVER_REFUND_V2: 'clover_refund_response_v2',
    CLOVER_TERMINAL_SALE: 'clover_terminal_sale_response_v1',
    CLOVER_TERMINAL_SALE_V2: 'clover_terminal_sale_response_v2',
    CLOVER_TERMINAL_TOKENIZATION: 'clover_terminal_tokenization_response_v1',
    CLOVER_TERMINAL_CANCEL: 'clover_terminal_cancel_response_v1',
    CLOVER_VOID: 'clover_void_response_v1',
    CLOVER_VOID_V2: 'clover_void_response_v2',
    GATEWAY_TERMINAL_SALE: 'gateway_terminal_sale_response',
    VALOR_RECONCILE: 'valor_reconcile_response_v1',
    VALOR_RECONCILE_V2: 'valor_reconcile_response_v2',
    VALOR_REFUND: 'valor_refund_response_v1',
    VALOR_REFUND_V2: 'valor_refund_response_v2',
    VALOR_BROWSER_TOKENIZATION: 'valor_browser_tokenization_response_v1',
    VALOR_SALE_COPY: 'valor_sale_copy_response_v1',
    VALOR_SALE_COPY_V2: 'valor_sale_copy_response_v2',
    VALOR_SALE_COPY_HTTP_ERROR: 'valor_sale_copy_http_error_response_v1',
    VALOR_SALE_COPY_HTTP_ERROR_V2: 'valor_sale_copy_http_error_response_v2',
    VALOR_SALE_COPY_INVALID_JSON: 'valor_sale_copy_invalid_json_response_v1',
    VALOR_SALE_COPY_INVALID_JSON_V2: 'valor_sale_copy_invalid_json_response_v2',
    VALOR_TRANSACTION_LIST: 'valor_transaction_list_response_v1',
    VALOR_TRANSACTION_LIST_V2: 'valor_transaction_list_response_v2',
    VALOR_TRANSACTION_STATUS: 'valor_transaction_status_response_v1',
    VALOR_TRANSACTION_STATUS_V2: 'valor_transaction_status_response_v2',
    VALOR_TXN_FETCH: 'valor_txnfetch_response_v1',
    VALOR_TXN_FETCH_V2: 'valor_txnfetch_response_v2',
    VALOR_VC_CANCEL: 'valor_vc_cancel_response_v1',
    VALOR_VC_PUBLISH: 'valor_vc_publish_response_v1',
    VALOR_VC_PUBLISH_V2: 'valor_vc_publish_response_v2',
    VALOR_VC_STATUS: 'valor_vc_status_response_v1',
    VALOR_VC_STATUS_V2: 'valor_vc_status_response_v2',
    VALOR_VOID: 'valor_void_response_v1',
    VALOR_VOID_V2: 'valor_void_response_v2',
} as const;

export type GatewayLifecycleResponseType =
    (typeof GatewayLifecycleResponseType)[keyof typeof GatewayLifecycleResponseType];

export interface ProviderGatewayResponseSnapshot extends JsonObject {}

export type CardPointeRawGatewayLifecycleResponseType =
    | typeof GatewayLifecycleResponseType.CARDPOINTE_AUTH_V2
    | typeof GatewayLifecycleResponseType.CARDPOINTE_AUTH_HTTP_ERROR_V2
    | typeof GatewayLifecycleResponseType.CARDPOINTE_BROWSER_TOKENIZATION_V2
    | typeof GatewayLifecycleResponseType.CARDPOINTE_FUNDING_V2
    | typeof GatewayLifecycleResponseType.CARDPOINTE_HOSTED_IFRAME_TOKENIZATION_V2
    | typeof GatewayLifecycleResponseType.CARDPOINTE_INQUIRE_V2
    | typeof GatewayLifecycleResponseType.CARDPOINTE_INQUIRE_BY_ORDER_ID_V2
    | typeof GatewayLifecycleResponseType.CARDPOINTE_REFUND_V2
    | typeof GatewayLifecycleResponseType.CARDPOINTE_TERMINAL_CANCEL_V2
    | typeof GatewayLifecycleResponseType.CARDPOINTE_TERMINAL_SALE_V2
    | typeof GatewayLifecycleResponseType.CARDPOINTE_TERMINAL_TOKENIZATION_V2
    | typeof GatewayLifecycleResponseType.CARDPOINTE_VOID_V2;

export type CloverRawGatewayLifecycleResponseType =
    | typeof GatewayLifecycleResponseType.CLOVER_CHARGE_V2
    | typeof GatewayLifecycleResponseType.CLOVER_BROWSER_TOKENIZATION_V2
    | typeof GatewayLifecycleResponseType.CLOVER_PAYMENT_V2
    | typeof GatewayLifecycleResponseType.CLOVER_PAYMENT_EXTERNAL_V2
    | typeof GatewayLifecycleResponseType.CLOVER_PAYMENT_EXTERNAL_HTTP_ERROR_V2
    | typeof GatewayLifecycleResponseType.CLOVER_WEBHOOK_PAYMENT_RETRIEVAL_V2
    | typeof GatewayLifecycleResponseType.CLOVER_REFUND_V2
    | typeof GatewayLifecycleResponseType.CLOVER_TERMINAL_SALE_V2
    | typeof GatewayLifecycleResponseType.CLOVER_TERMINAL_TOKENIZATION
    | typeof GatewayLifecycleResponseType.CLOVER_TERMINAL_CANCEL
    | typeof GatewayLifecycleResponseType.CLOVER_VOID_V2;

export type ValorRawGatewayLifecycleResponseType =
    | typeof GatewayLifecycleResponseType.VALOR_BROWSER_TOKENIZATION
    | typeof GatewayLifecycleResponseType.VALOR_RECONCILE_V2
    | typeof GatewayLifecycleResponseType.VALOR_REFUND_V2
    | typeof GatewayLifecycleResponseType.VALOR_SALE_COPY_V2
    | typeof GatewayLifecycleResponseType.VALOR_SALE_COPY_HTTP_ERROR_V2
    | typeof GatewayLifecycleResponseType.VALOR_SALE_COPY_INVALID_JSON_V2
    | typeof GatewayLifecycleResponseType.VALOR_TRANSACTION_LIST_V2
    | typeof GatewayLifecycleResponseType.VALOR_TRANSACTION_STATUS_V2
    | typeof GatewayLifecycleResponseType.VALOR_TXN_FETCH_V2
    | typeof GatewayLifecycleResponseType.VALOR_VC_CANCEL
    | typeof GatewayLifecycleResponseType.VALOR_VC_PUBLISH_V2
    | typeof GatewayLifecycleResponseType.VALOR_VC_STATUS_V2
    | typeof GatewayLifecycleResponseType.VALOR_VOID_V2;

export const GatewayLifecycleStructuredResponseTypes = [
    GatewayLifecycleResponseType.VALOR_TXN_FETCH,
    GatewayLifecycleResponseType.VALOR_VC_STATUS,
    GatewayLifecycleResponseType.VALOR_SALE_COPY_INVALID_JSON,
    GatewayLifecycleResponseType.CLOVER_CHARGE_INVALID_JSON,
    GatewayLifecycleResponseType.CLOVER_CHARGE,
    GatewayLifecycleResponseType.CLOVER_LIFECYCLE_PREFLIGHT,
    GatewayLifecycleResponseType.CLOVER_LIFECYCLE_FINALIZATION,
    GatewayLifecycleResponseType.CLOVER_PAYMENT,
    GatewayLifecycleResponseType.CLOVER_PAYMENT_EXTERNAL,
    GatewayLifecycleResponseType.CLOVER_REFUND,
    GatewayLifecycleResponseType.CLOVER_TERMINAL_SALE,
    GatewayLifecycleResponseType.CLOVER_VOID,
    GatewayLifecycleResponseType.CLOVER_WEBHOOK_PAYMENT_RETRIEVAL,
] as const;

export type GatewayLifecycleStructuredResponseType =
    (typeof GatewayLifecycleStructuredResponseTypes)[number];

export type GatewayLifecycleDiagnosticResponseType = Exclude<
    GatewayLifecycleResponseType,
    | GatewayLifecycleStructuredResponseType
    | CardPointeRawGatewayLifecycleResponseType
    | CloverRawGatewayLifecycleResponseType
    | ValorRawGatewayLifecycleResponseType
>;

export interface CloverWebhookPaymentRetrievalResponseSnapshot extends JsonObject {
    readonly id: string;
}

export interface ValorCardMetadataSnapshot extends JsonObject {
    readonly CARD_BIN?: string;
    readonly CARD_TYPE?: string;
    readonly ISSUING_BANK?: string;
    readonly COUNTRY?: string;
    readonly CARD_LEVEL?: string;
    readonly CARD_CATEGORY?: string;
}

export interface ValorTaxComponentSnapshot extends JsonObject {
    readonly rate: LosslessNumber;
    readonly amount: number | string;
    readonly taxableSales: number | string;
}

export interface ValorTaxDetailsSnapshot extends JsonObject {
    readonly stateTax?: ValorTaxComponentSnapshot;
    readonly cityTax?: ValorTaxComponentSnapshot;
    readonly reducedTax?: ValorTaxComponentSnapshot;
}

export interface ValorTxnFetchRecordSnapshot extends JsonObject {
    readonly REF_TXN_ID?: string;
    readonly TXN_ID?: string;
    readonly BASE_AMOUNT?: string;
    readonly NET_AMOUNT?: string;
    readonly CUSTOM_FEE_AMOUNT?: string;
    readonly TOTAL_TAX?: string | number;
    readonly IS_VOID?: string;
    readonly IS_SETTLED?: string;
    readonly REFUND_AMOUNT?: string;
    readonly REFUND_COUNT?: string;
    readonly CARD_SCHEME?: string;
    readonly PAN?: string;
    readonly CARDHOLDER_NAME?: string;
    readonly AUTH_CODE?: string;
    readonly APPROVAL_CODE?: string;
    readonly RRN?: string;
    readonly STAN_NO?: string;
    readonly BATCH_NO?: string;
    readonly CARD_TYPE?: string;
    readonly CARD_METADATA?: ValorCardMetadataSnapshot;
    readonly TAX_DETAILS?: ValorTaxDetailsSnapshot;
}

export interface ValorTxnFetchGatewayResponseSnapshot extends JsonObject {
    readonly data: ValorTxnFetchRecordSnapshot[];
    readonly error_no?: string;
    readonly status?: string;
    readonly number_of_records?: number;
    readonly meta?: JsonObject;
}

export interface ValorVcStatusGatewayResponseSnapshot extends JsonObject {
    readonly response: {
        readonly REQ_TXN_ID?: string;
        readonly STATE?: string;
        readonly EPI?: string;
        readonly SERIAL_NO?: string;
        readonly STAN_ID?: string;
        readonly INVOICENUMBER?: string;
        readonly INITIATOR_NAME?: string;
        readonly AMOUNT?: string;
        readonly PARTIAL?: string;
        readonly TOTAL_AMOUNT?: string;
        readonly ISSUER?: string;
        readonly TRAN_TYPE?: string;
        readonly MASKED_PAN?: string;
        readonly RRN?: string;
        readonly CODE?: string;
        readonly BATCH_NO?: string;
        readonly CARDHOLDER_NAME?: string;
        readonly TXN_ID?: string;
        readonly TRAN_METHOD?: string;
        readonly [key: string]: JsonValue | undefined;
    };
    readonly error_no?: string;
}

export type GatewayLifecycleResponseJsonBody =
    | JsonValue
    | ProviderGatewayResponseSnapshot
    | ValorTxnFetchGatewayResponseSnapshot
    | ValorVcStatusGatewayResponseSnapshot
    | CloverCnpTokenSaleChargeBody
    | CloverLifecyclePreflightResponsePayload
    | CloverLifecycleFinalizationResponsePayload
    | CloverTransactionDetailsPaymentBody
    | CloverRefundResponseDetails
    | CloverTerminalSaleResponseLifecyclePayload
    | CloverVoidResponseDetails
    | CloverWebhookPaymentRetrievalResponseSnapshot;

export type GatewayLifecycleResponseVariant<
    TResponseType extends GatewayLifecycleResponseType,
    TGatewayResponseJson extends GatewayLifecycleResponseJsonBody | null,
> = {
    readonly gateway_response_type: TResponseType;
    readonly gateway_response_json: TGatewayResponseJson;
};

export type GatewayLifecycleResponse =
    | GatewayLifecycleResponseVariant<
          typeof GatewayLifecycleResponseType.VALOR_TXN_FETCH,
          ValorTxnFetchGatewayResponseSnapshot
      >
    | GatewayLifecycleResponseVariant<
          typeof GatewayLifecycleResponseType.VALOR_VC_STATUS,
          ValorVcStatusGatewayResponseSnapshot
      >
    | GatewayLifecycleResponseVariant<
          typeof GatewayLifecycleResponseType.VALOR_SALE_COPY_INVALID_JSON,
          null
      >
    | GatewayLifecycleResponseVariant<
          typeof GatewayLifecycleResponseType.CLOVER_CHARGE_INVALID_JSON,
          null
      >
    | GatewayLifecycleResponseVariant<
          typeof GatewayLifecycleResponseType.CLOVER_CHARGE,
          CloverCnpTokenSaleChargeBody
      >
    | GatewayLifecycleResponseVariant<
          typeof GatewayLifecycleResponseType.CLOVER_LIFECYCLE_PREFLIGHT,
          CloverLifecyclePreflightResponsePayload
      >
    | GatewayLifecycleResponseVariant<
          typeof GatewayLifecycleResponseType.CLOVER_LIFECYCLE_FINALIZATION,
          CloverLifecycleFinalizationResponsePayload
      >
    | GatewayLifecycleResponseVariant<
          typeof GatewayLifecycleResponseType.CLOVER_PAYMENT,
          CloverTransactionDetailsPaymentBody
      >
    | GatewayLifecycleResponseVariant<
          typeof GatewayLifecycleResponseType.CLOVER_PAYMENT_EXTERNAL,
          CloverTransactionDetailsPaymentBody
      >
    | GatewayLifecycleResponseVariant<
          typeof GatewayLifecycleResponseType.CLOVER_REFUND,
          CloverRefundResponseDetails
      >
    | GatewayLifecycleResponseVariant<
          typeof GatewayLifecycleResponseType.CLOVER_TERMINAL_SALE,
          CloverTerminalSaleResponseLifecyclePayload
      >
    | GatewayLifecycleResponseVariant<
          typeof GatewayLifecycleResponseType.CLOVER_VOID,
          CloverVoidResponseDetails
      >
    | GatewayLifecycleResponseVariant<
          typeof GatewayLifecycleResponseType.CLOVER_WEBHOOK_PAYMENT_RETRIEVAL,
          CloverWebhookPaymentRetrievalResponseSnapshot
      >
    | GatewayLifecycleResponseVariant<CardPointeRawGatewayLifecycleResponseType, JsonValue>
    | GatewayLifecycleResponseVariant<CloverRawGatewayLifecycleResponseType, JsonValue>
    | GatewayLifecycleResponseVariant<ValorRawGatewayLifecycleResponseType, JsonValue>
    | GatewayLifecycleResponseVariant<
          GatewayLifecycleDiagnosticResponseType,
          ProviderGatewayResponseSnapshot
      >;
